// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function () {  // Add this
	
	BoostPFS.inject(this);  // Add this
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
	};

    var inputValue;
    SearchInput.prototype.beforeRender = function() {
      inputValue = this.$element.val()
    }
    
    SearchInput.prototype.afterRender = function() {
      var currentValue = this.$element.val();
      
      if (!currentValue && inputValue) this.$element.val(inputValue);
    }
})();  // Add this at the end